import { defineMessages } from 'react-intl';

const messages = defineMessages({
    filterButton: {
        id: 'FloatingSearchButtonIcon.filterButton.label',
        defaultMessage: 'Filter',
        description: 'Label of the FloatingSearchButtonIcon',
    },
});

export default messages;
